import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ConfigurationBanner from './ConfigurationBanner';
import { DegradedModeBanner } from './DegradedModeBanner';
import { FeedbackButton } from './FeedbackButton';
import { UserGuideButton } from './UserGuideButton';

const Layout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <ConfigurationBanner />
      <Navbar />
      <main className="flex-grow">
        <div className="container mx-auto px-4 py-6">
          <DegradedModeBanner />
        </div>
        <Outlet />
      </main>
      <Footer />
      <FeedbackButton />
      <UserGuideButton />
    </div>
  );
};

export default Layout;